import React, { useCallback } from 'react'
import { hooks, ModelForm } from '@front/volcanion'
import Callbacks from './callbacks'
import { HookUtils } from '@front/volcanion/utils'
import { Loader } from '@front/squirtle'

const withForm = Component => ({
  isOrderDuplicate,
  order_id,
  setIsWaiting,
  isWaiting,
  disableHeader = false,
  disableHistory,
  disableMap,
  headerLabelProps,
  form_name = 'order_form',
}) => {
  const { openNotification } = hooks.useNotification()
  const [, { openDialog }] = hooks.useDialogs()
  const CODE_INTERNATIONAL = hooks.useRelayConstant('CODE_INTERNATIONAL')
  const getEstimation = hooks.useEstimationSelector()
  const [domain, domain_status] = hooks.useDetailedCurrentDomain({ mutator: 'domain_id' })
  const [order, order_status] = hooks.useModel('order', [order_id], { single: true })
  const [cp_id] = hooks.useGlobalFieldValues(form_name, ['commercial_package'])
  const [allowed_vehicle_options] = hooks.useAuthorizedVehicleOptions(cp_id, { mutator: 'vehicle_option_id' })
  const [allowed_driver_options] = hooks.useAuthorizedDriverOptions(cp_id, { mutator: 'user_option_id' })

  const modify_fields = Callbacks.getModifyFieldsHandler(order, isOrderDuplicate)()
  const formProps = {
    name: form_name,
    model_name: 'order',
    record_id: order_id,
    getEmptyState: useCallback(Callbacks.getEmptyStateHandler(domain), [domain]),
    getEmptyForm: useCallback(Callbacks.getEmptyFormHandler(), []),
    recordToForm: useCallback(Callbacks.recordToFormHandler(isOrderDuplicate), [isOrderDuplicate]),
    recordToState: useCallback(Callbacks.recordToStateHandler(isOrderDuplicate, domain), [isOrderDuplicate, domain]),
    formToRecord: useCallback(Callbacks.formToRecordHandler(CODE_INTERNATIONAL, getEstimation), [CODE_INTERNATIONAL, getEstimation]),
    formToOptions: useCallback(Callbacks.formToOptionsHandler(), []),
    modify_fields,
    populate: [
      'do.user_companies.companyuser_services.companyservice.contract',
      'do.info',
      'do.customerinfo',
      'do.auth',
      'commercial_package',
      'source.poi.type',
      'destination.poi',
      'service.contract',
      'info',
      'loads',
      'driver_estimation',
      'quotation',
      'driver_opts',
      'vehicle_opts',
      'specific_parameter',
      'job.payment',
      'job.orders',
      'assigned_transport.payment',
      'assigned_transport.info',
      'assigned_transport.driver',
      'reservationinfos',
      'mode.config',
      'transaction',
      'voucher'
    ],
    onSubmitFailed: useCallback(Callbacks.onSubmitFailedHandler(openDialog), [openDialog]),
    getFailedNotification: useCallback(Callbacks.getFailedNotificationHandler(), []),
    includeReadOnly: true,
    modifyChangesOnly: !isOrderDuplicate,
    baseRoute: isOrderDuplicate ? 'order' : null,
    beforeSubmit: useCallback(Callbacks.beforeSubmitHanbdler(
      openNotification, openDialog, allowed_driver_options, allowed_vehicle_options
    ), [
      openNotification, openDialog, allowed_driver_options, allowed_vehicle_options
    ])
  }
  const mergedProps = {
    disableHeader,
    disableHistory,
    disableMap,
    headerLabelProps,
    setIsWaiting,
    isWaiting
  }
  return (
    <Loader isLoading={HookUtils.getLoadingState([domain_status, order_status])}>
      <ModelForm {...formProps}>
        <Component {...mergedProps} />
      </ModelForm>
    </Loader>
  )
}

export default withForm
